(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["email-popup"] && !Shopify.designMode) return;
  try {
    (() => {
      const STORAGE_KEY = 'email_popup_closed';

      const hasSuccessIndicator = (urlValue = window.location.href) => {
        try {
          const url = new URL(urlValue, window.location.origin);
          return (
            url.searchParams.has('customer_posted') ||
            urlValue.includes('customer_posted=true') ||
            url.hash === '#contact_form' ||
            urlValue.includes('#contact_form')
          );
        } catch (error) {
          return urlValue.includes('customer_posted=true') || urlValue.includes('#contact_form');
        }
      };

      const isChallengePage = () => window.location.pathname.includes('/challenge');

      const getDaysSinceDismissal = (value) => {
        if (!value) return null;

        const dismissedAt = new Date(value);

        if (Number.isNaN(dismissedAt.getTime())) return null;

        return (Date.now() - dismissedAt.getTime()) / (1000 * 60 * 60 * 24);
      };

      const shouldShowPopup = (cookieDays) => {
        if (isChallengePage()) return false;

        const storedValue = window.localStorage.getItem(STORAGE_KEY);
        const daysSinceDismissal = getDaysSinceDismissal(storedValue);

        if (daysSinceDismissal === null) {
          if (storedValue) window.localStorage.removeItem(STORAGE_KEY);
          return true;
        }

        if (daysSinceDismissal < cookieDays) return false;

        window.localStorage.removeItem(STORAGE_KEY);
        return true;
      };

      const setDismissal = () => {
        window.localStorage.setItem(STORAGE_KEY, new Date().toISOString());
      };

      const initPopup = () => {
        const root = document.getElementById('EmailPopup');

        if (!root) return;

        const dialog = root.querySelector('.email-popup__dialog');
        const form = root.querySelector('.email-popup__form');
        const submitButton = root.querySelector('.email-popup__submit');
        const submitLabel = submitButton ? submitButton.querySelector('span') : null;
        const emailField = root.querySelector('.email-popup__input');
        const closeButtons = root.querySelectorAll('[data-email-popup-close]');
        const delay = Number(root.dataset.delay || 3) * 1000;
        const cookieDays = Number(root.dataset.cookieDays || 30);
        let timerId;
        let previouslyFocusedElement;

        if (!dialog || !form || !submitButton || !submitLabel || !emailField) return;

        const closePopup = () => {
          setDismissal();
          root.dataset.state = 'form';
          root.classList.remove('is-visible');
          root.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('overflow-hidden');
          if (previouslyFocusedElement) previouslyFocusedElement.focus();
        };

        const openPopup = (state) => {
          root.dataset.state = state;
          previouslyFocusedElement = document.activeElement;
          root.classList.add('is-visible');
          root.setAttribute('aria-hidden', 'false');
          document.body.classList.add('overflow-hidden');
          if (state === 'form') {
            window.requestAnimationFrame(() => emailField.focus());
          } else {
            window.requestAnimationFrame(() => dialog.focus());
          }
        };

        const setSubmitting = (isSubmitting) => {
          submitButton.disabled = isSubmitting;
          submitButton.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
          submitLabel.textContent = isSubmitting
            ? submitButton.dataset.loadingLabel
            : submitButton.dataset.defaultLabel;
        };

        closeButtons.forEach((button) => {
          button.addEventListener('click', closePopup);
        });

        document.addEventListener('keydown', (event) => {
          if (event.code.toUpperCase() !== 'ESCAPE') return;
          if (!root.classList.contains('is-visible')) return;
          closePopup();
        });

        form.addEventListener('submit', async (event) => {
          event.preventDefault();

          if (!emailField.value) return;

          setSubmitting(true);

          try {
            const response = await fetch('/contact#contact_form', {
              method: 'POST',
              redirect: 'follow',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              },
              body: new URLSearchParams(new FormData(form))
            });

            const finalUrl = response.url || '';

            if (finalUrl.includes('/challenge')) {
              window.location.href = finalUrl;
              return;
            }

            const isRedirect = response.redirected || (response.status >= 300 && response.status < 400);
            const isSuccess =
              isRedirect || hasSuccessIndicator(finalUrl) || response.status === 200 || response.ok;

            if (isSuccess) {
              setDismissal();
              form.reset();
              openPopup('success');
            } else {
              closePopup();
            }
          } catch (error) {
            if (!isChallengePage() && hasSuccessIndicator()) {
              setDismissal();
              form.reset();
              openPopup('success');
            } else {
              closePopup();
            }
          } finally {
            setSubmitting(false);
          }
        });

        if (!isChallengePage() && hasSuccessIndicator()) {
          setDismissal();
          openPopup('success');
          return;
        }

        if (!shouldShowPopup(cookieDays)) return;

        timerId = window.setTimeout(() => {
          if (shouldShowPopup(cookieDays)) openPopup('form');
        }, delay);

        window.addEventListener(
          'beforeunload',
          () => {
            if (timerId) window.clearTimeout(timerId);
          },
          { once: true }
        );
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPopup, { once: true });
      } else {
        initPopup();
      }
    })();
  } catch(e) { console.error(e); }
})();

})();
